module.exports = __webpack_public_path__ + "static/p01_letreroPoste-5f54fa0f3c910eb22d58488c93cb559e.png";